import { CircleHelp } from "lucide-react";

type MetricHelpProps = {
  helpText?: string;
  label?: string;
  className?: string;
};

export function MetricHelp({
  helpText,
  label = "Definição de métrica",
  className = "",
}: MetricHelpProps) {
  if (!helpText) return null;

  return (
    <span
      title={helpText}
      aria-label={label}
      role="img"
      className={`inline-flex cursor-help items-center text-slate-400 hover:text-slate-600 ${className}`}
    >
      <CircleHelp className="h-4 w-4" />
    </span>
  );
}
